export default __webpack_public_path__ + "static/media/home-banner-4.d2c31228.gif";